import React from 'react'
import Grid1 from './Grid1'
import {Link} from "react-router-dom";
function body() {
    return (
        <div className="gr">
                <Link to="/Search/sea=&city=3&catégories=0" className="b">
                  <Grid1 colors="#4a4a4a" text="TOUTES LES CATÉGORIES" img="https://www.avito.ma/img/cg-all.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=VEHICULES" className="b">
                  <Grid1 colors="red" text="VEHICULES" img="https://www.avito.ma/img/cg-cars.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=0" className="b">
                  <Grid1 on={true} colors="hsl(322, 44%, 42%)" text="AUTO NEUF" img="https://www.avito.ma/img/cg-cars-new.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=accessoires informatique et gadgets" className="b">
                  <Grid1 colors="hsl(149, 60%, 59%)" text="INFORMATIQUE ET MULTIMEDIA" img="https://www.avito.ma/img/cg-market.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=1000" className="b">
                  <Grid1 colors="hsl(203, 100%, 63%)" text="IMMOBILIER" img="https://www.avito.ma/img/cg-re.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=0" className="b">
                  <Grid1 colors="hsl(247, 100%, 75%)" text="IMMO NEUF" img="https://www.avito.ma/img/cg-immo.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=3000" className="b">
                  <Grid1 colors="#4a4a4a" text="POUR LA MAISON ET JARDIN" img="https://www.avito.ma/img/cg-garden.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=6000" className="b">
                  <Grid1 colors="#4a4a4a" text="EMPLOI ET SERVICES" img="https://www.avito.ma/img/cg-jobs.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=8000" className="b">
                  <Grid1 colors="#4a4a4a" text="HABILLEMENT ET BIEN ETRE" img="https://www.avito.ma/img/cg-clothing.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=4000" className="b">
                  <Grid1 colors="#4a4a4a" text="LOISIRS ET DIVERTISSEMENT" img="https://www.avito.ma/img/cg-leisure.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=9000" className="b">
                <Grid1 colors="#4a4a4a" text="ENTREPRISES" img="https://www.avito.ma/img/cg-entreprise.png"/>
                </Link>
                <Link to="/Search/sea=&city=3&catégories=7000" className="b">
                <Grid1 colors="#4a4a4a" text="AUTRES" img="https://www.avito.ma/img/cg-other.png"/>
                </Link>
            </div>
    )
}

export default body
